import { render } from "./Tabbar.vue?vue&type=template&id=d48e2db8&ts=true"
import script from "./Tabbar.vue?vue&type=script&lang=ts"
export * from "./Tabbar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__